"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimFieldMappings = exports.ClaimFieldNames = void 0;
var ClaimFieldNames;
(function (ClaimFieldNames) {
    ClaimFieldNames["claimID"] = "claimID";
    ClaimFieldNames["approvedLenderCode"] = "approvedLenderCode";
    ClaimFieldNames["approvedLenderEnglishName"] = "approvedLenderEnglishName";
    ClaimFieldNames["approvedLenderFrenchName"] = "approvedLenderFrenchName";
    ClaimFieldNames["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ClaimFieldNames["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ClaimFieldNames["claimReceivedDate"] = "claimReceivedDate";
    ClaimFieldNames["claimTypeCode"] = "claimTypeCode";
    ClaimFieldNames["claimTypeIndicator"] = "claimTypeIndicator";
    ClaimFieldNames["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ClaimFieldNames["correspondenceLanguage"] = "correspondenceLanguage";
    ClaimFieldNames["claimDecisionDate"] = "claimDecisionDate";
    ClaimFieldNames["claimStatus"] = "claimStatus";
    ClaimFieldNames["primaryBorrowerFirstName"] = "primaryBorrowerFirstName";
    ClaimFieldNames["primaryBorrowerLastName"] = "primaryBorrowerLastName";
    ClaimFieldNames["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ClaimFieldNames["recordCreatedUserID"] = "recordCreatedUserID";
    ClaimFieldNames["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ClaimFieldNames["recordUpdatedUserID"] = "recordUpdatedUserID";
    ClaimFieldNames["recordCreatedUserFullName"] = "recordCreatedUserFullName";
    ClaimFieldNames["recordUpdatedUserFullName"] = "recordUpdatedUserFullName";
    ClaimFieldNames["ownerFullName"] = "ownerFullName";
    ClaimFieldNames["newInternalAttachmentFlag"] = "newInternalAttachmentFlag";
    ClaimFieldNames["newInternalCommentFlag"] = "newInternalCommentFlag";
    ClaimFieldNames["newExternalAttachmentFlag"] = "newExternalAttachmentFlag";
    ClaimFieldNames["newExternalCommentFlag"] = "newExternalCommentFlag";
})(ClaimFieldNames = exports.ClaimFieldNames || (exports.ClaimFieldNames = {}));
var ClaimFieldMappings;
(function (ClaimFieldMappings) {
    ClaimFieldMappings["claimID"] = "claimID";
    ClaimFieldMappings["approvedLenderCode"] = "lender.approvedLenderCode";
    ClaimFieldMappings["approvedLenderEnglishName"] = "lenderName.approvedLenderEnglishName";
    ClaimFieldMappings["approvedLenderFrenchName"] = "lenderName.approvedLenderFrenchName";
    ClaimFieldMappings["approvedLenderReferenceNumber"] = "approvedLenderReferenceNumber";
    ClaimFieldMappings["approvedLenderTransitNumber"] = "approvedLenderTransitNumber";
    ClaimFieldMappings["claimReceivedDate"] = "indicator.claimReceivedDate";
    ClaimFieldMappings["claimTypeCode"] = "detail.claimTypeCode";
    ClaimFieldMappings["claimTypeIndicator"] = "claimTypeIndicator";
    ClaimFieldMappings["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    ClaimFieldMappings["correspondenceLanguage"] = "lender.correspondenceLanguageCode";
    ClaimFieldMappings["claimDecisionDate"] = "profile.claimDecisionDate";
    ClaimFieldMappings["claimStatus"] = "profile.claimStatus.code";
    ClaimFieldMappings["primaryBorrowerFirstName"] = "borrowers.0.firstName";
    ClaimFieldMappings["primaryBorrowerLastName"] = "borrowers.0.lastName";
    ClaimFieldMappings["recordCreatedTimestamp"] = "recordCreatedTimestamp";
    ClaimFieldMappings["recordCreatedUserID"] = "recordCreatedUserID";
    ClaimFieldMappings["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
    ClaimFieldMappings["recordUpdatedUserID"] = "recordUpdatedUserID";
    ClaimFieldMappings["recordCreatedUserFullName"] = "recordCreatedUserFullName";
    ClaimFieldMappings["recordUpdatedUserFullName"] = "recordUpdatedUserFullName";
    ClaimFieldMappings["ownerFullName"] = "ownerFullName";
    ClaimFieldMappings["newInternalAttachmentFlag"] = "newInternalAttachmentFlag";
    ClaimFieldMappings["newInternalCommentFlag"] = "newInternalCommentFlag";
    ClaimFieldMappings["newExternalAttachmentFlag"] = "newExternalAttachmentFlag";
    ClaimFieldMappings["newExternalCommentFlag"] = "newExternalCommentFlag";
})(ClaimFieldMappings = exports.ClaimFieldMappings || (exports.ClaimFieldMappings = {}));
